import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const APP_NAME = 'Contabilidad Clara';

const TITLES = {
    '/login': 'Iniciar Sesión',
    '/dashboard': 'Dashboard',
    '/dashboard/invoices': 'Facturas',
    '/dashboard/upload': 'Subir Factura',
    '/dashboard/users': 'Usuarios',
    '/dashboard/totals': 'Totales',
    '/dashboard/history': 'Historial Admin',
    '/dashboard/activities': 'Registro Facturas',
    '/dashboard/email-extractions': 'Extracciones de Correos',
    '/dashboard/daily-deposits': 'Depósitos del Día',
    '/dashboard/stripe-history': 'Historial Stripe',
    '/dashboard/extra-accounting': 'Contabilidad Extra',
    '/dashboard/trash': 'Papelera',
    '/dashboard/paypal': 'Transacciones PayPal',
};

// Sets the browser tab title per route: "Página · Contabilidad Clara"
export const PageTitle = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        const path = pathname.replace(/\/+$/, '') || '/';
        const page = TITLES[path];
        document.title = page ? `${page} · ${APP_NAME}` : APP_NAME;
    }, [pathname]);
    return null;
};

export default PageTitle;
